var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-6 pr-lg-5"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "select-field form-group mb-0"
  }, [_c('label', [_vm._v("Registration Type")]), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "label": "label",
      "options": [{
        label: 'I have a team',
        value: 'y'
      }, {
        label: 'Individual',
        value: 'i'
      }],
      "reduce": function (e) {
        return e.value;
      },
      "clearable": false
    },
    model: {
      value: _vm.team,
      callback: function ($$v) {
        _vm.team = $$v;
      },
      expression: "team"
    }
  }), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v("All team members are also eligible for individual prize money")]), _vm.getError('team') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Please select registration Type ")]) : _vm._e()], 1), _vm.isTeam ? _c('div', {
    staticClass: "input-field form-group mt-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.teamName,
      expression: "teamName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Team Name"
    },
    domProps: {
      "value": _vm.teamName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.teamName = $event.target.value.trim();
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v(_vm._s(_vm.event.team_help_text))]), _vm.getError('teamName') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" required ")]) : _vm._e()]) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }